module.exports = __webpack_public_path__ + "pcau/img/mother.616a24ba.jpg";